<template>
  <div id="breadcrumbs">
    <ul :class="breadcrumbsClass" class="breadcrumbs">
      <li v-for="(item, index) in items" class="breadcrumbs__item" :key="item.link || item.name || index">
        <span class="icon-arrow-expand breadcrumbs__icon"></span>
        <!-- last item mustn't have link -->
        <NuxtLink :to="item.link" v-if="(item.link && index !== items.length - 1) || singleItem">
          {{ item.name }}
        </NuxtLink>
        <span v-else>{{ item.name }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
  import { useMainStore } from '@/stores/main';

  export default {
    setup() {
      const mainStore = useMainStore();
      function setDataLayersPages() {
        if (mainStore.setDataLayersPages) mainStore.setDataLayersPages();
      }
      return { setDataLayersPages };
    },
    updated() {
      this.setDataLayersPages();
    },
    props: {
      breadcrumbsClass: '',
      singleItem: false,
      items: {
        default() {
          return [];
        },
        type: Array
      }
    }
  };
</script>
